import { render, staticRenderFns } from "./DeviceLanding.vue?vue&type=template&id=cb82ca8a&"
import script from "./DeviceLanding.vue?vue&type=script&lang=js&"
export * from "./DeviceLanding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports